import { render } from "./Remember.vue?vue&type=template&id=604a711a"
import script from "./Remember.vue?vue&type=script&lang=js"
export * from "./Remember.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\StudentManageSystem\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__